import { Button } from '@neo/index'
import { cn } from '@neo/lib/utils'
import { Label } from '@neo/primitives/label'

interface IVRKeypadProps {
  value: string[]
  onChange: (value: string[]) => void
  label: string
  onKeySelect?: (key: string) => void
}
export const IVRKeypad: React.FC<IVRKeypadProps> = ({ value, onChange, label, onKeySelect }) => {
  const handleChange = (selectedNum: string) => {
    const values = new Set(value)
    if (values.has(selectedNum)) values.delete(selectedNum)
    else values.add(selectedNum)

    const newVal = Array.from(values)
    onChange(newVal)
    onKeySelect?.(selectedNum)
  }
  return (
    <div>
      <Label>{label}</Label>
      <div className="flex items-center justify-center mt-2 py-3 bg-bg2 rounded-md">
        <div className="grid grid-cols-3 gap-3">
          {['1', '2', '3', '4', '5', '6', '7', '8', '9', '#', '0', '*'].map((num) => (
            <Button
              key={num}
              type="button"
              variant="outline"
              className={cn(
                'w-10 h-10 font-jetbrains text-p-400 tabular-nums tracking-normal hover:bg-hv1 rounded-lg shadow-none form-button',
                value?.includes(num) && 'border-primary hover:bg-background',
              )}
              onClick={() => handleChange(num)}
              aria-pressed={value?.includes(num)}
              data-testid={`button-ivr-key-${num === '#' ? 'hash' : num === '*' ? 'star' : num}`}
            >
              {num}
            </Button>
          ))}
        </div>
      </div>
    </div>
  )
}
